import "./index.css";
import { clsx } from "clsx";
import type { ISpinnerProps } from "./types";

export const Spinner = ({
  size = "sm",
  color = "brand",
  role = "status",
  className,
  translations,
  ref,
}: ISpinnerProps) => {
  const ariaLabel = translations?.ariaLabel || "Loading";
  const rootClass: string = clsx(
    "nuco-spinner",
    `nuco-spinner--${size}`,
    `nuco-color-${color}`,
    className,
  );

  return (
    <div ref={ref} className={rootClass} aria-label={ariaLabel} role={role}>
      <div className="nuco-spinner__inner" />
    </div>
  );
};
